import axiosInstance from '@/shared/api/axios';
import type {
  ApiAddressesDetailGetResponse,
  ApiAddressesGetItem,
  ApiAddressesGetResponse,
  ApiAddressesPostBody,
  ApiAddressesPutBody,
} from '@/shared/types/api/addresses';

export const apiAddressesGet = async (): Promise<ApiAddressesGetResponse> => {
  const { data } = await axiosInstance.get<ApiAddressesGetResponse>('/addresses');
  return data;
};

export const apiAddressGet = async (id: string): Promise<ApiAddressesDetailGetResponse> => {
  const { data } = await axiosInstance.get<ApiAddressesDetailGetResponse>(`/addresses/${id}`);
  return data;
};

export const apiAddressPost = async (
  body: ApiAddressesPostBody,
): Promise<ApiAddressesGetItem> => {
  const { data } = await axiosInstance.post<ApiAddressesGetItem>('/addresses', body);
  return data;
};

export const apiAddressPut = async (
  id: string,
  body: ApiAddressesPutBody,
): Promise<ApiAddressesGetItem> => {
  const { data } = await axiosInstance.put<ApiAddressesGetItem>(`/addresses/${id}`, body);
  return data;
};

export const apiAddressDelete = async (id: string): Promise<void> => {
  await axiosInstance.delete(`/addresses/${id}`);
};
